import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import {
  totalIrdOrdersSelector,
  fetchTotalIRDOrderDetails,
  topIrdItemsSelector,
  fetchTopIrdItems,
  topIrdItemsFilterSelector,
  fetchTopIrdItemsFilter,
  fetchIrdActivityList,
  irdActivityListSelector,
  irdUpsellActivityListSelector,
  fetchIrdUpsellActivityList,
} from '../AnalyticsSlice';
import moment from 'moment';
import CardWrapper from '../CardWrapper';
import {
  generatePdfTable,
  generateTotalReservationExportData,
  generateChartPdfExportData,
  getAllHotelDetails,
} from '../../../utils/analyticUtils';
import './ird.scss';
import SummaryCardWrapper from '../SummaryCardWrapper';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
//temporarily disable
// import zc from "@dvsl/zoomcharts";
import WidgetWrapper from '../WidgetWrapper';
import ImageCard from '../ImageCard';
import { ASSET_URL, ENVIRONMENT } from '../../../env/Configurations';
import TablePaginationActions from '../../../shared/table-pagination/TablePaginationActions';
import PreviewPopup from '../PreviewPopup';
import CustomPieChart from '../../../shared/charts/custom-pie-chart/CustomPieChart';
import CustomLineChart from '../../../shared/charts/custom-line-chart/CustomLineChart';
import StatisticsIrd from '../../statistics/ird/Ird';
import { decryptLocalStorage } from '../../../utils/authUtils';
import { statisticsDataKeys } from '../Analytics';
import { notificationManager } from '../../../utils/NotificationUtils';
import { filteredHotelsSelector, selectedHotelSelector } from '../../property/propertySlice';
import { isEmpty } from 'lodash';
import { getSelectedHotelName } from '../../../utils/commonUtils';

const Ird = (props) => {
  const {
    startDate,
    endDate,
    hotelId,
    showAllForReport = false,
    showLoader = () => {},
    setShowAllForReport = () => {},
  } = props;
  const dispatch = useDispatch();
  const totalIrdOrders = useSelector(totalIrdOrdersSelector);
  const topIrdItems = useSelector(topIrdItemsSelector);
  const topIrdItemsFilter = useSelector(topIrdItemsFilterSelector);
  const irdActivityList = useSelector(irdActivityListSelector);
  const irdUpsellActivityList = useSelector(irdUpsellActivityListSelector);
  const selectedHotel = useSelector(selectedHotelSelector);
  const selectedHotelList = useSelector(filteredHotelsSelector);

  const [isPreview, setIsPreview] = useState({ value: false, name: '' });
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [isHideExpand, setIsHideExpand] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [pieChartData, setPieChartData] = useState([]);
  const [totalOrderChartData, setTotalOrderChartData] = useState([]);
  const [totalOrderChartData2, setTotalOrderChartData2] = useState([]);
  const [currencyCode, setCurrencyCode] = useState(null);
  const [showNoData, setShowNoData] = useState(null);
  const parentElement = useRef(null);
  const currentHotelName = getSelectedHotelName(selectedHotelList, selectedHotel);

  const updateDataAvailability = () => {
    parentElement.current = document?.getElementById('ird-analytics');

    if (parentElement?.current?.childNodes?.length <= 0) {
      setShowNoData(true);
    } else {
      setShowNoData(false);
    }
  };

  useEffect(() => {
    onFetchTotalIrdData();
    onFetchTopIrdItems();
    onFetchTopIrdItemsFilter();
    onFetchIrdActivity();
    updateDataAvailability();
  }, [hotelId, startDate, endDate]);

  const epoch = (date) => {
    return moment(date).unix();
  };

  useEffect(() => {
    if (totalIrdOrders && totalIrdOrders?.totalOrdersGraph?.values) {
      let tempData = JSON.parse(totalIrdOrders?.totalOrdersGraph?.values);
      let tempData2 = JSON.parse(totalIrdOrders?.ordersByMenuGraph?.values);
      setCurrencyCode(() => totalIrdOrders?.totalRevenue?.currency);

      let totalChartData = tempData?.map((element, index) => {
        return {
          [statisticsDataKeys.date]: moment(new Date(element?.[0]) * 1000)?.format(
            statisticsDataKeys?.dateFormat,
          ),
          y: Number(element?.[1]),
          Count: element?.[1],
          Revenue: `${element?.[2]} ${currencyCode}`,
          month: moment(new Date(element?.[0]) * 1000)?.format(statisticsDataKeys?.monthFormat),
        };
      });
      setTotalOrderChartData(
        totalChartData?.sort((chart1, chart2) => {
          return (
            new Date(chart1?.[statisticsDataKeys.date]) -
            new Date(chart2?.[statisticsDataKeys.date])
          );
        }),
      );

      let totalChartData2 = tempData2?.map((element, index) => {
        return {
          [statisticsDataKeys.date]: moment(new Date(element?.[0]) * 1000)?.format(
            statisticsDataKeys?.dateFormat,
          ),
          y: element?.[1],
          revenue: element?.[2],
        };
      });
      setTotalOrderChartData2(
        totalChartData2.sort((chart1, chart2) => {
          return (
            new Date(chart1?.[statisticsDataKeys.date]) -
            new Date(chart2?.[statisticsDataKeys.date])
          );
        }),
      );
    }

    function calculatePieChartData(categoryList) {
      try {
        if (typeof categoryList === 'undefined' || isEmpty(categoryList)) {
          throw new Error('Category list is undefined or empty');
        }
        if (typeof categoryList !== 'string') {
          throw new Error('Invalid category list');
        }
      } catch (error) {
        if (ENVIRONMENT === 'dev') {
          console.error(error.message);
        }
        if (error.message === 'Invalid category list') {
          notificationManager('danger', error.message);
        }
        setPieChartData([]);
        return;
      }

      const parsedCategoryList = JSON.parse(categoryList);
      const calculatedPiechartData = parsedCategoryList
        ?.filter(({ value }) => value > 0)
        ?.map(({ name, value, revenue, percentage }) => ({
          name,
          value,
          revenue,
          percentage,
        }));

      setPieChartData(
        calculatedPiechartData.map((element) => ({
          label: element?.name,
          name: element?.name,
          value: Math.round(element?.percentage),
          valueWithPercent: element?.percentage?.toFixed(2)?.toString()?.concat('%'),
          Count: element?.value,
          Revenue: `${element?.revenue} ${currencyCode}`,
        })),
      );
    }
    calculatePieChartData(topIrdItems?.categoryList);

    updateDataAvailability();
  }, [totalIrdOrders, topIrdItems]);

  const onClickPieChart = (events, data) => {
    const currentValue = data?.slice?.data?.id;
    onFetchTopIrdItemsFilter(currentValue);
  };

  const onSelectionChange = (data) => {
    let temp = false;
    if (!data) {
      temp = false;
      setSelectedCategory('');
    } else if (data) {
      if (data?.slice?.selected) {
        setSelectedCategory(`of ${data?.slice?.data?.name}`);
      } else {
        setSelectedCategory('');
        onFetchTopIrdItemsFilter();
      }
      temp = data?.slice?.selected;
    }
    setIsHideExpand(temp);
  };

  const infoContents = (data) => {
    let info = '<div>';

    if (data?.name) {
      info +=
        "<p style='padding:10px 10px 0px 10px; text-align: center; font-weight: bold; border-bottom: 1px solid #333'>" +
        data?.name +
        '</p>';
    } else {
      info +=
        "<p style='padding:10px 10px 0px 10px; text-align: center; font-weight: bold; border-bottom: 1px solid #333'>NA</p>";
    }
    info += "<div style=''>";

    if (data?.menu) {
      info +=
        "<p style='padding-left: 10px'><span style='font-weight: bold'>" +
        data?.menu +
        '</span > </p>';
    }

    if (data?.value) {
      info +=
        "<p style='padding-left: 10px'><span style='font-weight: bold'>Item Count: </span><span style='padding: 0px 5px 0px 5px; color: #333'>" +
        data?.value +
        '</span > </p>';
    } else {
      info +=
        "<p style='padding-left: 10px'><span style='font-weight: bold'>Count: </span><span style='padding: 0px 5px 0px 5px;color: #333'> NA </span > </p>";
    }

    if (data?.revenue) {
      info +=
        "<p style='padding-left: 10px'><span style='font-weight: bold'>Revenue: </span><span style='padding: 0px 5px 0px 5px;color: #33'>" +
        data.revenue +
        '</span > </p>';
    } else {
      info +=
        "<p style='padding-left: 10px'><span style='font-weight: bold'>Revenue: </span><span style='padding: 0px 5px 0px 5px; color: #333'> " +
        topIrdItems?.totalItemRevenue +
        '</span > </p>';
    }

    info += '</div></div>';

    return info;
  };

  const onFetchTotalIrdData = () => {
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
      lang: language,
    };
    dispatch(fetchTotalIRDOrderDetails(payload));
  };

  const onFetchTopIrdItems = (categoryId = null) => {
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
      categoryId,
    };
    dispatch(fetchTopIrdItems(payload));
  };

  const onFetchTopIrdItemsFilter = (categoryId = null) => {
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
      categoryId,
    };
    dispatch(fetchTopIrdItemsFilter(payload));
  };

  const onFetchIrdActivity = () => {
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
    };
    dispatch(fetchIrdUpsellActivityList(payload));
    dispatch(fetchIrdActivityList(payload));
  };

  const addWaterMark = (doc) => {
    var totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(150);
      doc.setTextColor('#E5E5E5');
      doc.saveGraphicsState();
      doc.setGState(new doc.GState({ opacity: 0.5 }));
      doc.text('Hudini', 50, doc.internal.pageSize.height - 50, {
        angle: 45,
      });
      doc.restoreGraphicsState();
    }

    return doc;
  };

  const addPageNumber = (doc) => {
    var totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(12);
      doc.setTextColor('#00000');
      doc.text(100, doc.internal.pageSize.height - 5, `${i} of ${totalPages}`);
    }

    return doc;
  };

  const generateServicesPdf = () => {
    let body = [];
    let header = [];
    let menuBody = [];
    let menuHeader = [];
    if (totalIrdOrders && totalIrdOrders?.totalOrdersGraph?.values) {
      let tempData = JSON.parse(totalIrdOrders?.totalOrdersGraph?.values);
      body = generateChartPdfExportData(tempData);
      const tempRest = totalIrdOrders?.totalOrdersGraph?.labels;
      header = ['Date', ...tempRest];
    }

    if (totalIrdOrders && totalIrdOrders?.ordersByMenuGraph?.values) {
      let tempData = JSON.parse(totalIrdOrders?.ordersByMenuGraph?.values);
      menuBody = generateChartPdfExportData(tempData);
      const tempRest = totalIrdOrders?.ordersByMenuGraph?.menus;
      menuHeader = ['Date', ...tempRest];
    }
    let doc = new jsPDF(
      header.length > 10 ? { orientation: 'landscape' } : { orientation: 'portrait' },
    );
    doc.setTextColor('#6B6B6B');
    doc.setFontSize(32);
    //top heading
    const titleText = 'IN-ROOM DINING';
    const titleWidth = (doc.getStringUnitWidth(titleText) * 32) / doc.internal.scaleFactor;
    const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(centerX, 20, titleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(24);
    //subheading
    const subTitleText = 'IRD Orders';
    const subTitleWidth = (doc.getStringUnitWidth(subTitleText) * 24) / doc.internal.scaleFactor;
    const subTitleCenterX = (doc.internal.pageSize.width - subTitleWidth) / 2;
    doc.text(subTitleCenterX, 35, subTitleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(12);
    doc.text(20, 50, 'Generated Date:').setFont(undefined, 'bold');
    doc.text(70, 50, moment().format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 55, 'From Date:').setFont(undefined, 'bold');
    doc.text(70, 55, moment(startDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 60, 'To Date:').setFont(undefined, 'bold');
    doc.text(70, 60, moment(endDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 73, 'ORDERS').setFont(undefined, 'bold');

    doc.text(20, 80, 'Total Orders:').setFont(undefined, 'normal');
    doc
      .text(
        85,
        80,
        `${totalIrdOrders?.totalOrders?.count || 0}, ${round(
          totalIrdOrders?.totalOrders?.percentage || 0,
          1,
        )} %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 85, 'Total Revenue:').setFont(undefined, 'normal');
    doc
      .text(
        85,
        85,
        `${totalIrdOrders?.totalRevenue?.value || 0}, ${round(
          totalIrdOrders?.totalRevenue?.percentage || 0,
          1,
        )} %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 90, 'Avg Delivery Time:').setFont(undefined, 'normal');
    doc
      .text(
        85,
        90,
        `${totalIrdOrders?.avgDeliveryTime?.avgTime?.value || 0}, ${
          totalIrdOrders?.avgDeliveryTime?.difference || 0
        }  mins`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 95, 'Order Frequency per room:').setFont(undefined, 'normal');
    doc
      .text(
        85,
        95,
        `${totalIrdOrders?.orderPerDay?.ordersPerDay || 0}, ${round(
          totalIrdOrders?.orderPerDay?.percentage || 0,
          1,
        )} %`,
      )
      .setFont(undefined, 'bold');

    doc.text(20, 105, 'Total Orders').setFont(undefined, 'bold');

    doc.autoTable({
      headStyles: { fillColor: '#828282' },
      head: [header],
      body: body,
      startY: 110,
      theme: 'striped',
    });
    const calcRowItem = doc.autoTable.previous.finalY + 10;
    doc.text(20, calcRowItem, 'Orders By Menu').setFont(undefined, 'bold');

    doc.autoTable({
      headStyles: { fillColor: '#828282' },
      head: [menuHeader],
      body: menuBody,
      startY: calcRowItem + 5,
      theme: 'striped',
    });

    doc = addWaterMark(doc);
    doc = addPageNumber(doc);
    doc.save('Elevate-IRD-Orders.pdf');
  };

  const generateIrdItemsPdf = () => {
    let body = [];
    let header = ['Name', 'Value'];
    let topService = [];
    let topServicesHeader = ['Name', 'Count', 'Revenue'];
    let topUpsellService = [];
    if (topIrdItems && topIrdItems?.categoryList) {
      let categoryList = JSON.parse(topIrdItems?.categoryList);
      body = generatePdfTable(
        categoryList?.filter((item) => item?.value !== 0),
        ['name', 'value'],
      );
      topService = generatePdfTable(topIrdItemsFilter?.itemList, ['itemName', 'count', 'revenue']);
      topUpsellService = generatePdfTable(topIrdItemsFilter?.upsellItemList, [
        'itemName',
        'count',
        'revenue',
      ]);
    }
    let doc = new jsPDF(
      header.length > 10 ? { orientation: 'landscape' } : { orientation: 'portrait' },
    );
    doc.setTextColor('#6B6B6B');
    doc.setFontSize(32);
    //the top heading
    const titleText = 'IN-ROOM DINING';
    const titleWidth = (doc.getStringUnitWidth(titleText) * 32) / doc.internal.scaleFactor;
    const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(centerX, 20, titleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(24);
    //the sub heading
    const subTitleText = 'IRD Items';
    const subTitleWidth = (doc.getStringUnitWidth(subTitleText) * 24) / doc.internal.scaleFactor;
    const subTitleCenterX = (doc.internal.pageSize.width - subTitleWidth) / 2;
    doc.text(subTitleCenterX, 35, subTitleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(12);
    doc.text(20, 50, 'Generated Date:').setFont(undefined, 'bold');
    doc.text(70, 50, moment().format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 55, 'From Date:').setFont(undefined, 'bold');
    doc.text(70, 55, moment(startDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 60, 'To Date:').setFont(undefined, 'bold');
    doc.text(70, 60, moment(endDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');

    doc.text(20, 70, 'Categories').setFont(undefined, 'bold');
    autoTable(doc, {
      headStyles: { fillColor: '#828282' },
      head: [header],
      body: body,
      startY: 75,
      theme: 'striped',
    });

    const calcRowItem = 90 + body.length * 10;
    doc.text(20, calcRowItem, 'Top Selling Items' + selectedCategory).setFont(undefined, 'bold');
    doc
      .text(20, calcRowItem + 10, `Total Count: ${topIrdItemsFilter?.totalItemCount} `)
      .setFont(undefined, 'bold');
    doc
      .text(80, calcRowItem + 10, `Total Revenue: ${topIrdItemsFilter?.totalItemRevenue} `)
      .setFont(undefined, 'bold');
    autoTable(doc, {
      headStyles: { fillColor: '#828282' },
      head: [topServicesHeader],
      body: topService,
      startY: calcRowItem + 20,
      theme: 'striped',
    });
    const calcRowUpsell = calcRowItem + 30 + topService.length * 10;
    doc.text(20, calcRowUpsell, 'Top Upsell Items' + selectedCategory).setFont(undefined, 'bold');

    doc
      .text(20, calcRowUpsell + 10, `Total Count: ${topIrdItemsFilter?.totalUpsellCount} `)
      .setFont(undefined, 'bold');
    doc
      .text(80, calcRowUpsell + 10, `Total Revenue: ${topIrdItemsFilter?.totalUpsellRevenue} `)
      .setFont(undefined, 'bold');
    autoTable(doc, {
      headStyles: { fillColor: '#828282' },
      head: [topServicesHeader],
      body: topUpsellService,
      startY: calcRowUpsell + 20,
      theme: 'striped',
    });

    doc = addWaterMark(doc);
    doc = addPageNumber(doc);
    doc.save('Elevate-ird-items.pdf');
  };

  const round = (value, precision) => {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  };

  const isPositive = (value) => {
    return value > 0;
  };

  const handleClose = () => {
    setIsPreview({ value: false, name: '' });
    setRowsPerPage(5);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const TableData = () => {
    let data = isPreview.name === 'item' ? irdActivityList : irdUpsellActivityList;
    return (
      <TableContainer>
        <Table className='list-table ' aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>Rank</TableCell>
              <TableCell>Item Name</TableCell>
              <TableCell>Views on Item</TableCell>
              <TableCell>Added to Card</TableCell>
              <TableCell>Purchased</TableCell>
              <TableCell>Total Revenue</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : data
            )?.map((user, i) => (
              <TableRow key={i} className='border-white pointer'>
                <TableCell>{user?.rank}</TableCell>
                <TableCell>{user?.itemName}</TableCell>
                <TableCell>{user?.itemsViewed}</TableCell>
                <TableCell>{user?.itemsAddedToCart}</TableCell>
                <TableCell>{user?.purchased}</TableCell>
                <TableCell>{user?.totalRevenue}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow className='paginator'>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                count={data?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'Items per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    );
  };
  const irdSummaryMatrix = [
    {
      title: 'Total Orders',
      subTitle: 'Total Count',
      totalCount: totalIrdOrders?.totalOrders?.count || 0,
      uniqueCount: '',
    },
    {
      title: 'Total Revenue',
      subTitle: 'Total Revenue',
      totalCount: totalIrdOrders?.totalRevenue?.value || 0,
      uniqueCount: '',
    },
    {
      title: 'Order Frequency',
      subTitle: 'Orders Per Day',
      totalCount: totalIrdOrders?.orderPerDay?.ordersPerDay || 0,
      uniqueCount: '',
    },
  ];

  return (
    <>
      {showNoData ? (
        <span className='py-2'>
          Unable to generate reports due to third-party integration limitations.
        </span>
      ) : null}
      <div className='d-flex flex-column gap-3' id='Orders'>
        <CardWrapper
          title='Orders'
          hotelName={currentHotelName}
          startDate={startDate}
          showExportButton={true}
          endDate={endDate}
          onClickRefreshBtn={onFetchTotalIrdData}
          exportData={generateServicesPdf}
          excelData={generateTotalReservationExportData(
            totalIrdOrders,
            startDate,
            endDate,
            'ird-order',
          )}
          showLoader={showLoader}
          showAllForReport={showAllForReport}
          setShowAllForReport={setShowAllForReport}
        >
          <div className='d-flex flex-wrap p-3 col-12' id={'Orders'}>
            {irdSummaryMatrix?.map((summary, index) => (
              <SummaryCardWrapper
                key={index}
                title={summary?.title}
                subTitle={summary?.subTitle}
                total={summary?.totalCount?.toLocaleString()}
                uniqueCount={summary?.uniqueCount}
              />
            ))}
          </div>
          {totalOrderChartData?.length > 0 && (
            <WidgetWrapper
              title={'Total Orders'}
              width='95%'
              onClickRefreshBtn={onFetchTotalIrdData}
              isCustom={true}
              className='px-3'
            >
              <CustomLineChart
                key={1}
                xAxis={statisticsDataKeys.date}
                data={totalOrderChartData}
                sliderX={true}
                tooltipItems={[statisticsDataKeys.count, statisticsDataKeys.revenue]}
              />
            </WidgetWrapper>
          )}

          {totalOrderChartData2?.length > 0 && (
            <WidgetWrapper
              title={'Orders By Menu'}
              width='95%'
              onClickRefreshBtn={onFetchTotalIrdData}
              isCustom={true}
              className='px-3'
            >
              <CustomLineChart
                xAxis={statisticsDataKeys.date}
                data={totalOrderChartData2}
                sliderX={true}
              />
            </WidgetWrapper>
          )}

          {(topIrdItemsFilter?.itemList?.length > 0 ||
            topIrdItemsFilter?.upsellItemList?.length > 0) && (
            <CardWrapper
              title='Items'
              start={startDate}
              end={endDate}
              onClickRefreshBtn={onFetchTotalIrdData}
              exportData={generateIrdItemsPdf}
              excelData={generateTotalReservationExportData(
                topIrdItems,
                startDate,
                endDate,
                'ird-items',
              )}
              className='mx-3 mt-3'
            >
              <div className='col-12 mw-100 d-flex flex-column gap-3 p-3'>
                {topIrdItemsFilter?.itemList?.length > 0 && (
                  <WidgetWrapper
                    title={`Top Selling Items ${selectedCategory}`}
                    width='650px'
                    onClickExpand={() => setIsPreview({ value: true, name: 'item' })}
                    onClickRefreshBtn={() => {
                      onFetchTopIrdItems();
                      onFetchIrdActivity();
                    }}
                    isCustom={true}
                    className={'col p-0  position-relative'}
                    selectedCategory={selectedCategory}
                  >
                    <div className='mx-2 d-flex justify-content-around mt-4 analytic-top-five-container'>
                      {topIrdItemsFilter?.itemList?.slice(0, 5)?.map((img, i) => (
                        <ImageCard
                          key={i + 1}
                          title={img?.itemName}
                          count={i + 1}
                          subTitle1={`Count: ${img?.count?.toLocaleString()}`}
                          subTitle2={`Revenue: ${img?.revenue?.toLocaleString()} ${currencyCode}`}
                          url={
                            (img?.images &&
                              img?.images?.length > 0 &&
                              ASSET_URL + img?.images[0]?.master) ||
                            './assets/img/analytics/ird-no-image.png'
                          }
                        />
                      ))}
                    </div>
                    <div className='analytic-breaker-light mb-4' />
                    <div className='mx-2 d-flex'>
                      <div className='total-booking me-4 ms-1'>
                        <span>{topIrdItemsFilter?.totalItemCount?.toLocaleString()}</span>
                        <span className='total-title ms-1'>Top Selling Total Count</span>
                      </div>
                      <div className='total-booking me-4 ms-1'>
                        <span>
                          {topIrdItemsFilter?.totalItemRevenue?.toLocaleString()} {currencyCode}
                        </span>
                        <span className='total-title ms-1'>Total Revenue</span>
                      </div>
                    </div>
                  </WidgetWrapper>
                )}
              </div>

              {topIrdItemsFilter?.upsellItemList?.length > 0 && (
                <WidgetWrapper
                  title={`Top Upsell Items ${selectedCategory}`}
                  width='650px'
                  onClickExpand={() => setIsPreview({ value: true, name: 'upsell' })}
                  onClickRefreshBtn={() => {
                    onFetchTopIrdItems();
                    onFetchIrdActivity();
                  }}
                  isCustom={true}
                  selectedCategory={selectedCategory}
                >
                  <div className='mx-2 d-flex justify-content-around mt-4 analytic-top-five-container'>
                    {topIrdItemsFilter?.upsellItemList?.slice(0, 5)?.map((img, i) => (
                      <ImageCard
                        key={i + 1}
                        title={img?.itemName}
                        count={i + 1}
                        subTitle1={`Count: ${img?.count?.toLocaleString()}`}
                        subTitle2={`Revenue: ${img?.revenue?.toLocaleString()} ${currencyCode}`}
                        url={
                          (img?.images &&
                            img?.images?.length > 0 &&
                            ASSET_URL + img?.images[0]?.master) ||
                          './assets/img/analytics/ird-no-image.png'
                        }
                      />
                    ))}
                  </div>
                  <div className='analytic-breaker-light mb-4' />
                  <div className='mx-2 d-flex'>
                    <div className='total-booking me-4 ms-1'>
                      <span>{topIrdItemsFilter?.totalUpsellCount}</span>
                      <span className='total-title ms-1'>Total Counts</span>
                    </div>
                    <div className='total-booking me-4 ms-1'>
                      <span>
                        {topIrdItemsFilter?.totalUpsellRevenue?.toLocaleString()} {currencyCode}
                      </span>
                      <span className='total-title ms-1'>Total Revenue</span>
                    </div>
                  </div>
                </WidgetWrapper>
              )}
            </CardWrapper>
          )}
        </CardWrapper>

        <StatisticsIrd
          key='Ird'
          allStatisticsData={totalIrdOrders}
          showAllForReport={showAllForReport}
          currency={currencyCode}
        />

        {pieChartData?.length > 0 && (
          <WidgetWrapper
            title={'Categories'}
            width='450px'
            isCustom={true}
            onClickRefreshBtn={onFetchTopIrdItems}
            className={'col p-0 position-relative'}
          >
            <div className='text-center' style={{ height: '20rem' }}>
              <CustomPieChart
                data={pieChartData}
                tooltipItems={[statisticsDataKeys.count, statisticsDataKeys.revenue]}
              />
            </div>
          </WidgetWrapper>
        )}

        {topIrdItemsFilter &&
          (topIrdItemsFilter?.itemList?.length > 0 ||
            topIrdItemsFilter?.upsellItemList?.length > 0) &&
          isPreview.value && (
            <PreviewPopup
              viewPreviewStatus={isPreview?.value}
              handleClose={handleClose}
              title={isPreview.name === 'item' ? 'Top Selling Items' : 'Top Upsell Items'}
              subTitle1='Top 5 Items'
              subTitle2='Item Activity'
              topAppointment={
                isPreview.name === 'item'
                  ? topIrdItemsFilter?.itemList?.map((item) => {
                      return {
                        ...item,
                        name: item?.itemName,
                        sub1: `Count: ${item?.count?.toLocaleString()}`,
                        sub2: `Revenue: ${item?.revenue?.toLocaleString()}`,
                        img:
                          (item?.images &&
                            item?.images?.length > 0 &&
                            ASSET_URL + item.images[0]?.master) ||
                          './assets/img/analytics/ird-no-image.png',
                      };
                    })
                  : topIrdItemsFilter?.upsellItemList?.map((item) => {
                      return {
                        ...item,
                        name: item?.itemName,
                        sub1: `Count: ${item?.count?.toLocaleString()}`,
                        sub2: `Revenue: ${item?.revenue?.toLocaleString()}`,
                        img:
                          (item?.images &&
                            item?.images?.length > 0 &&
                            ASSET_URL + item.images[0]?.master) ||
                          './assets/img/analytics/ird-no-image.png',
                      };
                    })
              }
              count={
                isPreview.name === 'item'
                  ? topIrdItemsFilter?.totalItemCount?.toLocaleString()
                  : topIrdItemsFilter?.totalUpsellCount?.toLocaleString()
              }
              revenue={
                isPreview.name === 'item'
                  ? topIrdItemsFilter?.totalItemRevenue?.toLocaleString()
                  : topIrdItemsFilter?.totalUpsellRevenue?.toLocaleString()
              }
            >
              {<TableData />}
            </PreviewPopup>
          )}
      </div>
    </>
  );
};

export default Ird;
